webpackJsonp([199390669437303],{

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LightSwitchExample = exports.lampScxml = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _simpleLamp = __webpack_require__(887);
	
	var _simpleLamp2 = _interopRequireDefault(_simpleLamp);
	
	var _components = __webpack_require__(68);
	
	var _lampBulb = __webpack_require__(265);
	
	var _lampBulb2 = _interopRequireDefault(_lampBulb);
	
	var _lampSwitch = __webpack_require__(389);
	
	var _lampSwitch2 = _interopRequireDefault(_lampSwitch);
	
	var _lampBulb3 = __webpack_require__(333);
	
	var _lampBulb4 = _interopRequireDefault(_lampBulb3);
	
	var _lampSwitch3 = __webpack_require__(886);
	
	var _lampSwitch4 = _interopRequireDefault(_lampSwitch3);
	
	var _common = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var lampScxml = exports.lampScxml = _simpleLamp2.default;
	
	var LightSwitchExample = exports.LightSwitchExample = function (_SCComponent) {
	  _inherits(LightSwitchExample, _SCComponent);
	
	  function LightSwitchExample(props) {
	    _classCallCheck(this, LightSwitchExample);
	
	    return _possibleConstructorReturn(this, _SCComponent.call(this, props, lampScxml));
	  }
	
	  LightSwitchExample.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'table',
	        { style: { width: '100%', height: '400px' } },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(_common.Cell, {
	              contentHeight: '200px',
	              showSourceCode: this.state.showSourceCode,
	              sourceCode: _lampSwitch4.default,
	              component: _react2.default.createElement(_lampSwitch2.default, { sc: this.sc, configuration: this.state && this.state.configuration }),
	              caption: _react2.default.createElement(
	                'span',
	                null,
	                ' I am a ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'light switch'
	                ),
	                '.',
	                _react2.default.createElement('br', null),
	                ' You can ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'touch'
	                ),
	                ' me! '
	              )
	            }),
	            _react2.default.createElement(_common.Cell, {
	              contentHeight: '400px',
	              showSourceCode: this.state.showSourceCode,
	              sourceCode: lampScxml,
	              component: _react2.default.createElement(_schviz2.default, {
	                scxmlDocumentString: lampScxml,
	                disableAnimation: true,
	                configuration: this.state && this.state.configuration,
	                disableZoomAnimation: true,
	                transitionsEnabled: this.state && this.state.transitionsEnabled,
	                id: 'lightSwitch'
	              }),
	              caption: _react2.default.createElement(
	                'span',
	                null,
	                'I am a ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'state machine'
	                )
	              ),
	              rowSpan: '2'
	            })
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(_common.Cell, {
	              contentHeight: '200px',
	              overflow: 'hidden',
	              showSourceCode: this.state.showSourceCode,
	              sourceCode: _lampBulb4.default,
	              component: _react2.default.createElement(_lampBulb2.default, { configuration: this.state && this.state.configuration }),
	              caption: _react2.default.createElement(
	                'span',
	                null,
	                'I am a ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'light bulb'
	                ),
	                '.'
	              )
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(_components.ShowHideSourceCodeLink, { self: this })
	    );
	  };
	
	  return LightSwitchExample;
	}(_common.SCComponent);

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LampBulbFill = function LampBulbFill(_ref) {
	  var configuration = _ref.configuration;
	  return _react2.default.createElement('path', {
	    fillOpacity: configuration && configuration[0] === 'on' ? 0.7 : 0,
	    d: 'm27.1 30.824c7.2231-3.3965 10.352-12.066 6.9851-19.352-3.3674-7.2857-11.963-10.442-19.186-7.0455-7.2231 3.3965-10.352 12.066-6.9851 19.352 1.4846 3.212 3.7334 5.4935 6.9091 7.0095l-0.1362-0.10018-0.5 5.75 5.375 2.375 3.5-0.125 3.875-2 0.16283-5.8638z',
	    fill: 'url(#radialGradient3003)',
	    fillRule: 'evenodd',
	    style: { transition: 'fill-opacity .5s ease-out' }
	  });
	};
	
	var LampBulb = function LampBulb(_ref2) {
	  var configuration = _ref2.configuration;
	  return _react2.default.createElement(
	    'svg',
	    { version: '1.0', viewBox: '0 0 44 54', xmlns: 'http://www.w3.org/2000/svg', width: '100%', height: '100%' },
	    _react2.default.createElement(
	      'defs',
	      { id: 'defs2601' },
	      _react2.default.createElement(
	        'linearGradient',
	        { id: 'linearGradient3401', x1: '14.5', x2: '27.625', y1: '42', y2: '42', gradientUnits: 'userSpaceOnUse' },
	        _react2.default.createElement('stop', { stopColor: '#fff', offset: '0' }),
	        _react2.default.createElement('stop', { stopColor: '#e3e3e3', offset: '.5' }),
	        _react2.default.createElement('stop', { offset: '1' })
	      ),
	      _react2.default.createElement(
	        'filter',
	        { id: 'filter3407', x: '-.078906', y: '-.25042', width: '1.1578', height: '1.5008' },
	        _react2.default.createElement('feGaussianBlur', { id: 'feGaussianBlur3409', stdDeviation: '0.47487807' })
	      ),
	      _react2.default.createElement(
	        'radialGradient',
	        { id: 'radialGradient3003', cx: '17.922', cy: '16.813', r: '14.44', gradientTransform: 'matrix(1 0 0 1.238 .25 -4.8279)', gradientUnits: 'userSpaceOnUse' },
	        _react2.default.createElement('stop', { stopColor: '#fff', offset: '0' }),
	        _react2.default.createElement('stop', { stopColor: '#ffdc00', offset: '1' })
	      )
	    ),
	    _react2.default.createElement(LampBulbFill, { configuration: configuration }),
	    _react2.default.createElement('path', { d: 'm14.5 36.75 5.625 1.875h2.625l4.875-2.375v9.125l-4.75 2.375-4.125-0.25-4.25-2.125v-8.625z', fill: 'url(#linearGradient3401)', fillRule: 'evenodd' }),
	    _react2.default.createElement('path', { transform: 'translate(-.67762 .3306)', d: 'm15.333 30.78c-7.4843-3.4891-10.727-12.395-7.2376-19.879 3.4891-7.4843 12.395-10.727 19.879-7.2376 7.4843 3.4891 10.727 12.395 7.2376 19.879-1.5382 3.2995-3.8683 5.6432-7.1589 7.2006l0.1461 14.331c-4.125 3.25-8.8666 2.875-12.867 0v-14.294z', fill: 'none', stroke: '#000', strokeWidth: '1.2' }),
	    _react2.default.createElement('path', { d: 'm27.5 45.375s6.125-0.75 8.375 1.125 1.125 3-1.75 3.25-11.5-1.25-11.5-1.25', fillRule: 'evenodd', filter: 'url(#filter3407)', opacity: '.3' }),
	    _react2.default.createElement('path', { d: 'm27.411 42.362c-4.9053 3.4608-8.4916 2.9822-12.867 0', fill: 'none', stroke: '#000', strokeWidth: '1.2' }),
	    _react2.default.createElement('path', { d: 'm27.411 39.237c-4.9053 3.4608-8.4916 2.9822-12.867 0', fill: 'none', stroke: '#000', strokeWidth: '1.2' }),
	    _react2.default.createElement('path', { d: 'm27.411 36.3c-4.9053 3.4608-8.4916 2.9822-12.867 0', fill: 'none', stroke: '#000', strokeWidth: '1.2' }),
	    _react2.default.createElement('path', { d: 'm23.5 48.102c0 0.4155-0.24085 0.75-0.54003 0.75h-3.5449c-0.29918 0-0.54003-0.3345-0.54003-0.75 1.4961 0.078934 3.2922 0.091081 4.625 0z', fill: 'none', stroke: '#000', strokeWidth: '1.2' })
	  );
	};
	
	exports.default = LampBulb;
	module.exports = exports['default'];

/***/ }),

/***/ 333:
/***/ (function(module, exports) {

	module.exports = "import React from 'react'\n\nconst LampBulbFill = ({configuration}) => (\n  <path\n    fillOpacity={configuration && configuration[0] === 'on' ? 0.7 : 0} \n    d=\"m27.1 30.824c7.2231-3.3965 10.352-12.066 6.9851-19.352-3.3674-7.2857-11.963-10.442-19.186-7.0455-7.2231 3.3965-10.352 12.066-6.9851 19.352 1.4846 3.212 3.7334 5.4935 6.9091 7.0095l-0.1362-0.10018-0.5 5.75 5.375 2.375 3.5-0.125 3.875-2 0.16283-5.8638z\" \n    fill=\"url(#radialGradient3003)\" \n    fillRule=\"evenodd\" \n    style={{transition:'fill-opacity .5s ease-out'}}\n    />\n)\n\nconst LampBulb = ({configuration}) => (\n  <svg version=\"1.0\" viewBox=\"0 0 44 54\" xmlns=\"http://www.w3.org/2000/svg\" width=\"100%\" height=\"100%\">\n  <defs id=\"defs2601\">\n    <linearGradient id=\"linearGradient3401\" x1=\"14.5\" x2=\"27.625\" y1=\"42\" y2=\"42\" gradientUnits=\"userSpaceOnUse\">\n      <stop stopColor=\"#fff\" offset=\"0\"/>\n      <stop stopColor=\"#e3e3e3\" offset=\".5\"/>\n      <stop offset=\"1\"/>\n    </linearGradient>\n    <filter id=\"filter3407\" x=\"-.078906\" y=\"-.25042\" width=\"1.1578\" height=\"1.5008\">\n      <feGaussianBlur id=\"feGaussianBlur3409\" stdDeviation=\"0.47487807\"/>\n    </filter>\n    <radialGradient id=\"radialGradient3003\" cx=\"17.922\" cy=\"16.813\" r=\"14.44\" gradientTransform=\"matrix(1 0 0 1.238 .25 -4.8279)\" gradientUnits=\"userSpaceOnUse\">\n      <stop stopColor=\"#fff\" offset=\"0\"/>\n      <stop stopColor=\"#ffdc00\" offset=\"1\"/>\n    </radialGradient>\n  </defs>\n  <LampBulbFill configuration={configuration} />\n  <path d=\"m14.5 36.75 5.625 1.875h2.625l4.875-2.375v9.125l-4.75 2.375-4.125-0.25-4.25-2.125v-8.625z\" fill=\"url(#linearGradient3401)\" fillRule=\"evenodd\"/>\n  <path transform=\"translate(-.67762 .3306)\" d=\"m15.333 30.78c-7.4843-3.4891-10.727-12.395-7.2376-19.879 3.4891-7.4843 12.395-10.727 19.879-7.2376 7.4843 3.4891 10.727 12.395 7.2376 19.879-1.5382 3.2995-3.8683 5.6432-7.1589 7.2006l0.1461 14.331c-4.125 3.25-8.8666 2.875-12.867 0v-14.294z\" fill=\"none\" stroke=\"#000\" strokeWidth=\"1.2\"/>\n  <path d=\"m27.5 45.375s6.125-0.75 8.375 1.125 1.125 3-1.75 3.25-11.5-1.25-11.5-1.25\" fillRule=\"evenodd\" filter=\"url(#filter3407)\" opacity=\".3\"/>\n  <path d=\"m27.411 42.362c-4.9053 3.4608-8.4916 2.9822-12.867 0\" fill=\"none\" stroke=\"#000\" strokeWidth=\"1.2\"/>\n  <path d=\"m27.411 39.237c-4.9053 3.4608-8.4916 2.9822-12.867 0\" fill=\"none\" stroke=\"#000\" strokeWidth=\"1.2\"/>\n  <path d=\"m27.411 36.3c-4.9053 3.4608-8.4916 2.9822-12.867 0\" fill=\"none\" stroke=\"#000\" strokeWidth=\"1.2\"/>\n  <path d=\"m23.5 48.102c0 0.4155-0.24085 0.75-0.54003 0.75h-3.5449c-0.29918 0-0.54003-0.3345-0.54003-0.75 1.4961 0.078934 3.2922 0.091081 4.625 0z\" fill=\"none\" stroke=\"#000\" strokeWidth=\"1.2\"/>\n  </svg>\n);\n\nexport default LampBulb; \n"

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Switch = function Switch(_ref) {
	  var configuration = _ref.configuration;
	  return _react2.default.createElement('rect', {
	    transform: 'translate(-3.54e-6, ' + (configuration && configuration[0] === 'on' ? 0 : 57) + ')',
	    x: '149.15',
	    y: '165.42',
	    width: '55.864',
	    height: '110.64',
	    rx: '2.04',
	    ry: '1.875',
	    fill: '#fff',
	    style: { transition: 'transform .5s ease-out' } });
	};
	
	var LampSwitch = function LampSwitch(_ref2) {
	  var sc = _ref2.sc,
	      configuration = _ref2.configuration;
	  return _react2.default.createElement(
	    'svg',
	    {
	      onClick: function onClick(e) {
	        sc.gen('touch');
	      },
	      style: { position: 'absolute' }, width: '100%', height: '100%', id: 'svg2', enableBackground: 'new 0 0 356.251 512', version: '1.1', viewBox: '0 0 356.25 512' },
	    _react2.default.createElement('path', { d: 'm178.39 100.6c9.886 0 17.973-8.088 17.973-17.965 0-9.965-8.087-17.965-17.973-17.965-9.965 0-18.053 8-18.053 17.965 0 9.877 8.088 17.965 18.053 17.965z', fill: '#231f20' }),
	    _react2.default.createElement('path', { d: 'm178.39 406.01c-9.965 0-18.053 7.991-18.053 17.965 0 9.877 8.088 17.965 18.053 17.965 9.886 0 17.973-8.088 17.973-17.965 0-9.974-8.086-17.965-17.973-17.965z', fill: '#231f20' }),
	    _react2.default.createElement('path', { d: 'm302.36 0h-248.46c-29.72 0-53.896 24.176-53.896 53.896v404.21c0 29.719 24.176 53.895 53.896 53.895h248.46c29.72 0 53.896-24.176 53.896-53.896v-404.21c-1e-3 -29.72-24.177-53.896-53.897-53.896zm35.931 458.1c0 19.817-16.114 35.93-35.93 35.93h-248.46c-19.812 0-35.93-16.114-35.93-35.93v-404.21c0-19.817 16.118-35.93 35.93-35.93h248.46c19.817 0 35.93 16.114 35.93 35.93v404.21z', fill: '#231f20' }),
	    _react2.default.createElement('rect', { x: '131.8', y: '148.61', width: '91.119', height: '203.93', rx: '2.04', ry: '1.875', fill: '#231f20' }),
	    _react2.default.createElement('rect', { transform: 'translate(-3.54e-6)', x: '149.15', y: '165.42', width: '55.864', height: '110.64', rx: '2.04', ry: '1.875', fillOpacity: '0' }),
	    _react2.default.createElement(Switch, { configuration: configuration })
	  );
	};
	
	exports.default = LampSwitch;
	module.exports = exports['default'];

/***/ }),

/***/ 886:
/***/ (function(module, exports) {

	module.exports = "import React from 'react'\n\nconst Switch = ({configuration}) => (\n  <rect \n    transform={`translate(-3.54e-6, ${configuration && configuration[0] === 'on' ? 0 : 57})`} \n    x=\"149.15\" \n    y=\"165.42\" \n    width=\"55.864\" \n    height=\"110.64\" \n    rx=\"2.04\" \n    ry=\"1.875\" \n    fill=\"#fff\" \n    style={{transition:'transform .5s ease-out'}} />\n)\n\nconst LampSwitch = ({sc, configuration}) => (\n  <svg \n    onClick={(e) => { sc.gen('touch') }}\n    style={{position: 'absolute'}} width=\"100%\" height=\"100%\" id=\"svg2\" enableBackground=\"new 0 0 356.251 512\" version=\"1.1\" viewBox=\"0 0 356.25 512\">\n    <path d=\"m178.39 100.6c9.886 0 17.973-8.088 17.973-17.965 0-9.965-8.087-17.965-17.973-17.965-9.965 0-18.053 8-18.053 17.965 0 9.877 8.088 17.965 18.053 17.965z\" fill=\"#231f20\"/>\n    <path d=\"m178.39 406.01c-9.965 0-18.053 7.991-18.053 17.965 0 9.877 8.088 17.965 18.053 17.965 9.886 0 17.973-8.088 17.973-17.965 0-9.974-8.086-17.965-17.973-17.965z\" fill=\"#231f20\"/>\n    <path d=\"m302.36 0h-248.46c-29.72 0-53.896 24.176-53.896 53.896v404.21c0 29.719 24.176 53.895 53.896 53.895h248.46c29.72 0 53.896-24.176 53.896-53.896v-404.21c-1e-3 -29.72-24.177-53.896-53.897-53.896zm35.931 458.1c0 19.817-16.114 35.93-35.93 35.93h-248.46c-19.812 0-35.93-16.114-35.93-35.93v-404.21c0-19.817 16.118-35.93 35.93-35.93h248.46c19.817 0 35.93 16.114 35.93 35.93v404.21z\" fill=\"#231f20\"/>\n    <rect x=\"131.8\" y=\"148.61\" width=\"91.119\" height=\"203.93\" rx=\"2.04\" ry=\"1.875\" fill=\"#231f20\"/>\n    <rect transform=\"translate(-3.54e-6)\" x=\"149.15\" y=\"165.42\" width=\"55.864\" height=\"110.64\" rx=\"2.04\" ry=\"1.875\" fillOpacity=\"0\"/>\n    <Switch configuration={configuration} />\n  </svg>\n);\n\nexport default LampSwitch; \n"

/***/ }),

/***/ 887:
/***/ (function(module, exports) {

	module.exports = "<scxml \n  xmlns=\"http://www.w3.org/2005/07/scxml\"\n  version=\"1.0\"\n  name=\"simpleLamp\">\n  <state id=\"off\">\n    <transition event=\"touch\" target=\"on\"/>\n  </state>\n  <state id=\"on\">\n    <transition event=\"touch\" target=\"off\"/>\n  </state>\n</scxml>\n"

/***/ }),

/***/ 709:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(709);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LampSwitchButtons = function LampSwitchButtons(_ref) {
	  var sc = _ref.sc;
	  return _react2.default.createElement(
	    'ul',
	    { className: 'buttons' },
	    _react2.default.createElement(
	      'li',
	      null,
	      ' ',
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary', onClick: function onClick(e) {
	            sc.gen('switch-on');
	          } },
	        ' Switch On '
	      ),
	      ' '
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      ' ',
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-secondary', onClick: function onClick(e) {
	            sc.gen('switch-off');
	          } },
	        ' Switch Off '
	      ),
	      ' '
	    )
	  );
	};
	
	exports.default = LampSwitchButtons;
	module.exports = exports['default'];

/***/ }),

/***/ 898:
/***/ (function(module, exports) {

	module.exports = "import React from 'react'\nimport './buttons.css'\n\nconst LampSwitchButtons = ({sc}) => (\n  <ul className=\"buttons\">\n    <li> <button className=\"btn btn-primary\" onClick={(e) => {sc.gen('switch-on')}}> Switch On </button> </li>\n    <li> <button className=\"btn btn-secondary\" onClick={(e) => {sc.gen('switch-off')}}> Switch Off </button> </li>\n  </ul>\n);\n\nexport default LampSwitchButtons \n"

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TwoButtonLightSwitchExample = exports.lampScxml = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _scxml = __webpack_require__(28);
	
	var _scxml2 = _interopRequireDefault(_scxml);
	
	var _twoButtonLamp = __webpack_require__(899);
	
	var _twoButtonLamp2 = _interopRequireDefault(_twoButtonLamp);
	
	var _buttons = __webpack_require__(401);
	
	var _buttons2 = _interopRequireDefault(_buttons);
	
	var _buttons3 = __webpack_require__(898);
	
	var _buttons4 = _interopRequireDefault(_buttons3);
	
	var _lampBulb = __webpack_require__(265);
	
	var _lampBulb2 = _interopRequireDefault(_lampBulb);
	
	var _lampBulb3 = __webpack_require__(333);
	
	var _lampBulb4 = _interopRequireDefault(_lampBulb3);
	
	var _components = __webpack_require__(68);
	
	var _common = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var lampScxml = exports.lampScxml = _twoButtonLamp2.default;
	
	var TwoButtonLightSwitchExample = exports.TwoButtonLightSwitchExample = function (_SCComponent) {
	  _inherits(TwoButtonLightSwitchExample, _SCComponent);
	
	  function TwoButtonLightSwitchExample(props) {
	    _classCallCheck(this, TwoButtonLightSwitchExample);
	
	    return _possibleConstructorReturn(this, _SCComponent.call(this, props, lampScxml));
	  }
	
	  TwoButtonLightSwitchExample.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'table',
	        { style: { width: '100%', height: '400px' } },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(_common.Cell, {
	              contentHeight: '200px',
	              showSourceCode: this.state.showSourceCode,
	              sourceCode: _buttons4.default,
	              component: _react2.default.createElement(_buttons2.default, { sc: this.sc, configuration: this.state && this.state.configuration }),
	              caption: _react2.default.createElement(
	                'span',
	                null,
	                ' Switches '
	              )
	            }),
	            _react2.default.createElement(_common.Cell, {
	              contentHeight: '400px',
	              showSourceCode: this.state.showSourceCode,
	              sourceCode: lampScxml,
	              component: _react2.default.createElement(_schviz2.default, {
	                scxmlDocumentString: lampScxml,
	                disableAnimation: true,
	                configuration: this.state && this.state.configuration,
	                disableZoomAnimation: true,
	                transitionsEnabled: this.state && this.state.transitionsEnabled,
	                id: 'twoButtonLightSwitch'
	              }),
	              caption: _react2.default.createElement(
	                'span',
	                null,
	                'State machine'
	              ),
	              rowSpan: '2'
	            })
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(_common.Cell, {
	              contentHeight: '200px',
	              overflow: 'hidden',
	              showSourceCode: this.state.showSourceCode,
	              sourceCode: _lampBulb4.default,
	              component: _react2.default.createElement(_lampBulb2.default, { configuration: this.state && this.state.configuration }),
	              caption: _react2.default.createElement(
	                'span',
	                null,
	                'Light Bulb'
	              )
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(_components.ShowHideSourceCodeLink, { self: this })
	    );
	  };
	
	  return TwoButtonLightSwitchExample;
	}(_common.SCComponent);

/***/ }),

/***/ 899:
/***/ (function(module, exports) {

	module.exports = "<scxml\n  xmlns=\"http://www.w3.org/2005/07/scxml\"\n  version=\"1.0\"\n  name=\"twoButtonLamp\">\n  <state id=\"off\">\n    <transition event=\"switch-on\" target=\"on\"/>\n  </state>\n  <state id=\"on\">\n    <transition event=\"switch-off\" target=\"off\"/>\n  </state>\n</scxml>\n"

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _TutorialPageWrapper = __webpack_require__(18);
	
	var _TutorialPageWrapper2 = _interopRequireDefault(_TutorialPageWrapper);
	
	var _lightSwitchExample = __webpack_require__(388);
	
	var _twoButtonLamp = __webpack_require__(402);
	
	var _prismjs = __webpack_require__(38);
	
	var _prismjs2 = _interopRequireDefault(_prismjs);
	
	var _reactPrism = __webpack_require__(22);
	
	var _reactPrism2 = _interopRequireDefault(_reactPrism);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Introduction = function Introduction(_ref) {
	  var sectionName = _ref.sectionName,
	      by = _ref.by;
	  return React.createElement(
	    'div',
	    { className: 'container' },
	    React.createElement(
	      'h1',
	      null,
	      sectionName
	    ),
	    React.createElement(
	      'h6',
	      null,
	      by
	    ),
	    React.createElement(
	      'h2',
	      null,
	      'What is a state machine?'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'A state machine can be thought of as a graph, with nodes, and edges connecting those nodes. The nodes are called ',
	      React.createElement(
	        'strong',
	        null,
	        'states'
	      ),
	      ', and the edges are called ',
	      React.createElement(
	        'strong',
	        null,
	        'transitions'
	      ),
	      '. Transitions are associated with named ',
	      React.createElement(
	        'strong',
	        null,
	        'events'
	      ),
	      '. When you execute the state machine, you create a new state machine ',
	      React.createElement(
	        'strong',
	        null,
	        'instance'
	      ),
	      ', and that instance has a particular ',
	      React.createElement(
	        'strong',
	        null,
	        'configuration'
	      ),
	      ' of states, which is a Set of state ids that the instance is currently in. The state machine receives events, selects transitions from those events, and then flows along the transitions from source to target states, and updates its configuration to the set of target states.'
	    ),
	    React.createElement(
	      'h2',
	      null,
	      'Example: a light switch'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Let\u2019s say you have a light switch. Whenever you touch it, it turns on if it was off and off if it was on.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'So you have two states: ',
	      React.createElement(
	        'strong',
	        null,
	        'on'
	      ),
	      ' and ',
	      React.createElement(
	        'strong',
	        null,
	        'off'
	      ),
	      '. You also have one event: ',
	      React.createElement(
	        'strong',
	        null,
	        'touch'
	      ),
	      '. You can organize this into a statechart like so:'
	    ),
	    React.createElement(_lightSwitchExample.LightSwitchExample, null),
	    React.createElement(
	      'h2',
	      null,
	      'Example: two buttons, one light'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Now say we have one of those antique light switches that operates a light with two buttons: one for "off", and one for "on". Pressing "off" while the light is already off does nothing, and the same for the converse.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'For the buttons we have two events, "switch-off" and "switch-on" respectively. For the light we have two states, "on" and "off". That looks like this:'
	    ),
	    React.createElement(_twoButtonLamp.TwoButtonLightSwitchExample, null),
	    React.createElement(
	      'p',
	      null,
	      'From a design standpoint, this configuration takes a little more effort on the user\u2019s part because the user has to decide what she intends to do, which determines which button to press. But perhaps this light consumes a lot of energy to turn on, so accidentally turning the light off is intentionally designed to require more thought.'
	    )
	  );
	};
	
	var WrappedIntroduction = function WrappedIntroduction(_ref2) {
	  var location = _ref2.location;
	  return React.createElement(_TutorialPageWrapper2.default, { Component: Introduction, pathname: location.pathname });
	};
	
	exports.default = WrappedIntroduction;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-introduction-js-0344da356cb43161031e.js